import RoleGuard from "@/pages/role-guard";
import { Permissions } from "@/utils/permissions";
import { lazy } from "react";
import { makeHandle } from "./router.helpers";

const TemplatesPage = lazy(() => import("@/pages/templates"));

const TemplateEditor = lazy(
  () => import("@/pages/templates/components/DocumentEditor"),
);

const DetalleEmailTemplate = lazy(() =>
  import("@/pages/templates/components/DetalleEmailTemplate").then((m) => ({
    default: m.DetalleEmailTemplate,
  })),
);

const DetalleSmsTemplate = lazy(() =>
  import("@/pages/templates/components/DetalleSmsTemplate").then((m) => ({
    default: m.DetalleSmsTemplate,
  })),
);

export const createPlantillasRoutes = (isSmsEnabled: boolean) => ({
  path: "plantillas",
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          canHaveSomePermissions
          permissions={[
            Permissions["email-templates"].read,
            Permissions["document-templates"].read,
            Permissions["sms-templates"].read,
          ]}
        >
          <TemplatesPage />
        </RoleGuard>
      ),
      handle: makeHandle({ label: "Plantillas" }),
    },
    {
      path: "documentos/:id",
      element: (
        <RoleGuard permissions={[Permissions["document-templates"].update]}>
          <TemplateEditor />
        </RoleGuard>
      ),
      handle: makeHandle(
        { label: "Plantillas", path: "/plantillas" },
        { label: "Editor" },
      ),
    },
    {
      path: "correos/:id",
      element: (
        <RoleGuard permissions={[Permissions["email-templates"].read]}>
          <DetalleEmailTemplate />
        </RoleGuard>
      ),
      handle: makeHandle(
        { label: "Plantillas", path: "/plantillas" },
        { label: "Detalle de plantilla" },
      ),
    },
    isSmsEnabled
      ? {
          path: "sms/:id",
          element: (
            <RoleGuard permissions={[Permissions["sms-templates"].read]}>
              <DetalleSmsTemplate />
            </RoleGuard>
          ),
          handle: makeHandle(
            { label: "Plantillas", path: "/plantillas" },
            { label: "Detalle de plantilla SMS" },
          ),
        }
      : {},
  ],
});
